import { render, staticRenderFns } from "./ExplanatoryCard.vue?vue&type=template&id=28f6fcde&scoped=true&"
var script = {}
import style0 from "./ExplanatoryCard.vue?vue&type=style&index=0&id=28f6fcde&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6fcde",
  null
  
)

export default component.exports